import React, { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { UserInfoContext } from "../../contexts/UserInfo.context";
import { apiService } from "../../services/api.service";
import { getDateTime } from "../../utils";
import { StatusContext } from "../../contexts/Status.context";
import useTranslation from "../../hooks/useTranslation";
import CommonBtn from "../../components/buttons/commonBtn";
import { FaFacebook, FaLinkedinIn, FaTwitter } from "react-icons/fa";

const FinishSection = () => {
  const { email, ip, score, userId, setScore } = useContext(UserInfoContext);
  const { module, setProblemNumber, setPageStatus, setEngine, setMechanics } =
    useContext(StatusContext);
  const { t } = useTranslation();

  const saveMainScore = async () => {
    try {
      const dateTime = getDateTime();
      const data = `score=${dateTime},${userId.replaceAll(
        ",",
        " "
      )},${email},${ip},${score},${module}`;
      const result = await apiService.saveMainScore(data);
    } catch (error) {}
  };

  useEffect(() => {
    saveMainScore();
  }, []);

  const returnToHome = () => {
    setPageStatus("Menu");
    setMechanics(0);
    setEngine("menu");
    setProblemNumber(0);
    setScore(0);
  };

  return (
    <div className="text-center">
      <div className="mt-4 mb-4 text-2xl font-bold">
        {t("Your Score")}: {Number(score) >= 0 ? score : 0}
      </div>
      <div className="my-8">
        <CommonBtn status={3} onClick={() => returnToHome()}>
          {t("Return to main menu")}
        </CommonBtn>
      </div>
      <div className="mt-16 mb-2 text-2xl font-bold">
        {t("SHARE YOUR SCORE")}
      </div>
      <div className="w-[90%] md:w-[60%] mx-auto flex justify-between">
        <a
          href="https://twitter.com/intent/tweet?text=Members&url=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
          target="_blank"
          className="mx-2 bg-[#1da1f2] w-full flex justify-center p-2"
        >
          <FaTwitter />
        </a>
        <a
          href="https://www.facebook.com/share.php?u=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
          target="_blank"
          className="mx-2 bg-[#1877f2] w-full flex justify-center p-2"
        >
          <FaFacebook />
        </a>
        <a
          href="https://www.linkedin.com/cws/share?url=https%3A%2F%2Fmicroexpressionstrainingvideos.com%2Fmembers%2F"
          target="_blank"
          className="mx-2 bg-[#2767b1] w-full flex justify-center p-2"
        >
          <FaLinkedinIn />
        </a>
      </div>
      <div className="mt-16 mb-4">
        {t(
          "Embed the free Micro Expressions Test on your website with this code"
        )}
        :
      </div>
      <textarea
        className="text-black w-[70%] md:w-[40%]"
        value={`<iframe src="https://www.microexpressionstest.com/micro-expressions-test/" width=1010 height=650></iframe>`}
      ></textarea>
    </div>
  );
};

export default FinishSection;
